import Service from "../Service";

const resource = "inventory/";

export default {
    lista(requestID) {
        return Service.get(resource + "lista", {
            params: { requestID: requestID },
        });
    },
    activoFijo(codigoInventario, requestID) {
        return Service.get(resource + "activofijo/" + codigoInventario, {
            params: { requestID: requestID },
        });
    },
    evidencia(codigoActivo, codigoInventario, requestID) {
        return Service.get(resource + "evidencia/" + codigoActivo + "/" + codigoInventario, {
            params: { requestID: requestID },
        });
    },
    evidenciaBase64(codigoActivo, codigoInventario, requestID) {
        return Service.get(resource + "evidencia/base64/" + codigoActivo + "/" + codigoInventario, {
            params: { requestID: requestID },
        });
    },
};
